'use client';

import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { cn } from '@/lib/utils';

// 定义单元格数据结构
interface CellData {
  content: string;
  rowSpan?: number;
  colSpan?: number;
}

// 定义表头数据结构
interface HeaderCell {
  content: string;
  colSpan?: number;
  rowSpan?: number;
}

interface SizeTableProps {
  headers: HeaderCell[][]; // 支持多行表头
  data: (CellData | string)[][]; // 每个单元格可以是字符串或带合并属性的对象
}

export const SizeTable = ({ headers, data }: SizeTableProps) => {
  // 将字符串转换为 CellData 对象
  const normalizeCell = (cell: CellData | string): CellData => {
    if (typeof cell === 'string') {
      return {
        content: cell,
      };
    }

    return cell;
  };

  return (
    <div className='w-full'>
      <Table>
        <TableHeader className='border-r-1 border-[#D0D0D0]'>
          {headers.map((row, rowIndex) => (
            <TableRow
              key={rowIndex}
              className='h-[50px] border-[#D0D0D0]'
            >
              {row.map((header, colIndex) => (
                <TableHead
                  key={colIndex}
                  rowSpan={header.rowSpan}
                  colSpan={header.colSpan}
                  className='border-l-1 border-[#D0D0D0] bg-[#E0E0E0] text-center font-roboto-regular text-[16px] font-normal '
                >
                  {header.content}
                </TableHead>
              ))}
            </TableRow>
          ))}
        </TableHeader>
        <TableBody className='border-r-1 border-[#D0D0D0]'>
          {data.map((row, rowIndex) => (
            <TableRow
              key={rowIndex}
              className={cn('h-[50px] border-[#f0f0f0]', rowIndex % 2 === 0 ? 'bg-white' : 'bg-[#f8f8f8]')}
            >
              {row.map((cell, colIndex) => {
                const normalizedCell = normalizeCell(cell);

                return (
                  <TableCell
                    key={colIndex}
                    rowSpan={normalizedCell.rowSpan}
                    colSpan={normalizedCell.colSpan}
                    className='border-l-1 border-[#D0D0D0] text-center font-roboto-light text-[16px] font-light text-primary'
                  >
                    {normalizedCell.content}
                  </TableCell>
                );
              })}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
};
